
const CONVERT_INVOICE_TO_VOID = '/invoice/convert/void/-10';

module.exports =  {
    convertInvoiceToVoid: function convertInvoiceToVoid(invoiceId) {
        let form = new FormData();
        form.set('forAjax', true);
        form.set('invoiceId', invoiceId);
        return window.axios.post(CONVERT_INVOICE_TO_VOID, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    }
}